import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import Home from './views/Home.vue'
import Chart from './views/Chart.vue'
import Login from './views/Login.vue'
import Rules from './views/Rules.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/chart',
      name: 'chart',
      component: Chart
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/rules',
      name: 'rules',
      component: Rules
    }
  ]
});

// Un utilisateur non connecté est redirigé vers la page de connexion
router.beforeEach ((to, from, next) =>
{
  if (!store.state.connecte && to.name != 'login') {
    next({name: 'login'});
  } else {
    next();
  }
});

export default router;